/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SessionAnalysisDTO
 */
export interface SessionAnalysisDTO {
    [key: string]: any | any;
    /**
     * 
     * @type {number}
     * @memberof SessionAnalysisDTO
     */
    score?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SessionAnalysisDTO
     */
    pitchMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SessionAnalysisDTO
     */
    pitchMax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SessionAnalysisDTO
     */
    comfortableMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SessionAnalysisDTO
     */
    comfortableMax?: number | null;
}

/**
 * Check if a given object implements the SessionAnalysisDTO interface.
 */
export function instanceOfSessionAnalysisDTO(value: object): value is SessionAnalysisDTO {
    return true;
}

export function SessionAnalysisDTOFromJSON(json: any): SessionAnalysisDTO {
    return SessionAnalysisDTOFromJSONTyped(json, false);
}

export function SessionAnalysisDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionAnalysisDTO {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'score': json['score'] == null ? undefined : json['score'],
        'pitchMin': json['pitchMin'] == null ? undefined : json['pitchMin'],
        'pitchMax': json['pitchMax'] == null ? undefined : json['pitchMax'],
        'comfortableMin': json['comfortableMin'] == null ? undefined : json['comfortableMin'],
        'comfortableMax': json['comfortableMax'] == null ? undefined : json['comfortableMax'],
    };
}

export function SessionAnalysisDTOToJSON(json: any): SessionAnalysisDTO {
    return SessionAnalysisDTOToJSONTyped(json, false);
}

export function SessionAnalysisDTOToJSONTyped(value?: SessionAnalysisDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'score': value['score'],
        'pitchMin': value['pitchMin'],
        'pitchMax': value['pitchMax'],
        'comfortableMin': value['comfortableMin'],
        'comfortableMax': value['comfortableMax'],
    };
}

